"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var style_1 = require("../../../style");
var layout_1 = require("../../layout");
var containerSizeMap = {
    xxs: 16,
    xs: 24,
    sm: 32,
    md: 40,
    lg: 48,
    xl: 56,
    xxl: 64,
};
var borderWidthMap = {
    xxs: 1,
    xs: 2,
    sm: 4,
    md: 6,
    lg: 8,
    xl: 10,
    xxl: 12,
};
var getBorderRadius = function (size, theme) {
    if (theme === 'light-square' || theme === 'mid-square' || theme === 'dark-square') {
        return borderWidthMap[size] + 2;
    }
    return containerSizeMap[size] / 2;
};
var getBackgroundColor = function (color, theme) {
    if (theme === 'mid-square') {
        return style_1.DesignSystemThemeColor[color].DEFAULT;
    }
    else if (theme === 'dark-square') {
        return style_1.DesignSystemThemeColor[color].DARK_3;
    }
    else if (theme === 'dark-circle') {
        return style_1.DesignSystemThemeColor[color].DEFAULT;
    }
    return style_1.DesignSystemThemeColor[color].LIGHT_4;
};
var getStyles = function (size, color, theme) {
    var containerPx = containerSizeMap[size] + "px";
    var borderRadius = getBorderRadius(size, theme) + "px";
    var backgroundColor = getBackgroundColor(color, theme);
    return react_1.css({
        width: containerPx,
        height: containerPx,
        minWidth: containerPx,
        minHeight: containerPx,
        backgroundColor: backgroundColor,
        borderRadius: borderRadius,
        outline: theme === 'light-circle-outline'
            ? borderWidthMap[size] / 2 + "px solid " + style_1.DesignSystemThemeColor[color].LIGHT_5 : '',
        border: theme === 'light-circle-outline'
            ? borderWidthMap[size] / 2 + "px solid " + style_1.DesignSystemThemeColor[color].LIGHT_5 : '',
    });
};
var getIcon = function (icon, size, color, theme) {
    var Icon = icon;
    var iconSize = containerSizeMap[size] / 2;
    var iconColor = theme === 'mid-square' || theme === 'dark-square' || theme === 'dark-circle'
        ? style_1.SixsenseColor.White.DEFAULT
        : style_1.DesignSystemThemeColor[color].DARK_1;
    return react_1.jsx(Icon, { size: iconSize, color: iconColor });
};
var FeaturedIcon = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'md' : _b, _c = _a.color, color = _c === void 0 ? 'Primary' : _c, _d = _a.theme, theme = _d === void 0 ? 'light-circle' : _d, icon = _a.icon, props = __rest(_a, ["size", "color", "theme", "icon"]);
    var styles = getStyles(size, color, theme);
    var iconJSX = getIcon(icon, size, color, theme);
    return (react_1.jsx(layout_1.Flex, __assign({ alignItems: "center", justifyContent: "center", css: styles }, props), iconJSX));
};
exports.default = FeaturedIcon;
